export interface MotionProfile {
  readonly bodyRippleScale: number;
  readonly cameraFollowRatePerSecond: number;
  readonly cameraLookAheadDistance: number;
  readonly guidanceDurationMs: number;
  readonly guidanceStaticOffsetPx: number;
  readonly guidanceTravelPx: number;
  readonly particleDurationMs: number;
  readonly particleOpacity: number;
  readonly particleTravelPx: number;
  readonly pulseDurationMs: number;
  readonly pulseScale: number;
  readonly roundPulseScale: number;
  readonly screenTransitionDistancePx: number;
  readonly screenTransitionDurationMs: number;
  readonly snakeMotionScale: number;
}

export const motionConfig: {
  readonly reduced: MotionProfile;
  readonly standard: MotionProfile;
} = {
  reduced: {
    bodyRippleScale: 0.2,
    cameraFollowRatePerSecond: 20,
    cameraLookAheadDistance: 72,
    guidanceDurationMs: 1,
    guidanceStaticOffsetPx: 32,
    guidanceTravelPx: 0,
    particleDurationMs: 1,
    particleOpacity: 0,
    particleTravelPx: 0,
    pulseDurationMs: 1,
    pulseScale: 1,
    roundPulseScale: 1,
    screenTransitionDistancePx: 0,
    screenTransitionDurationMs: 1,
    snakeMotionScale: 0,
  },
  standard: {
    bodyRippleScale: 1,
    cameraFollowRatePerSecond: 5,
    cameraLookAheadDistance: 180,
    guidanceDurationMs: 1_400,
    guidanceStaticOffsetPx: 0,
    guidanceTravelPx: 84,
    particleDurationMs: 520,
    particleOpacity: 1,
    particleTravelPx: 26,
    pulseDurationMs: 420,
    pulseScale: 1.08,
    roundPulseScale: 1.08,
    screenTransitionDistancePx: 18,
    screenTransitionDurationMs: 260,
    snakeMotionScale: 1,
  },
};
